import React from 'react';
// Coupon or Voucher follow ups/early bird deadline - Set 3
const TwelveStepTemplate = ({ values }) => {
  const {
    client_name,
    conference_short_name,
    registration_link,
    deadline_date,
    your_name,
    contact_details
  } = values;
  return (
    <div>
      <p>{client_name ? `Hi ${client_name}` : `Hi [Recipient's Name],`}</p>
      <p>
        This is your <strong>final opportunity</strong> to take advantage of the
        exclusive Early Bird discount for{' '}
        <strong>
          {' '}
          {conference_short_name
            ? conference_short_name
            : `[Conference Short Name]`}{' '}
        </strong>
        before it expires on{' '}
        <strong>{deadline_date ? deadline_date : `[Deadline Date]`}</strong>.
      </p>

      <p>
        Don’t miss out on this chance to:
        <br />
        ✅ Join leading experts in groundbreaking discussions
        <br />✅ Enhance your professional credentials
        <br />✅ Network with top researchers and professionals from around the
        world
      </p>

      <p>
        Key Highlights of the Conference:
        <br />
        🌟 <strong>CPD Accreditation:</strong> Earn a globally recognized CPD
        certification.
        <br />
        🌟 <strong>Publication Opportunities:</strong> Get your work published
        in Scopus, Web of Science, or SCI-indexed journals.
        <br />
        🌟 <strong>Global Networking:</strong> Connect with peers and experts
        worldwide.
        <br />
        🌟 <strong>Innovative Sessions:</strong> Engage in discussions aligned
        with the United Nations SDGs and global research trends.
      </p>
      <p>
        {registration_link ? (
          <>
            <strong>👉 Register Here: </strong>
            <a
              href={registration_link}
              target="_blank"
              rel="noopener noreferrer"
            >
              Click Here
            </a>
          </>
        ) : (
          <strong>👉 Register Here: [Registration Link]</strong>
        )}
      </p>

      <p>
        <strong>Early Bird Deadline: </strong>{' '}
        {deadline_date ? deadline_date : `[Deadline Date]`}
      </p>
      <p>
        Act now to secure your spot at a discounted rate. Let me know if you
        have any questions or need assistance with registration!
      </p>
      <div>
        <strong>Best regards,</strong>
      </div>
      <div>{your_name ? your_name : '[Your Name]'}</div>
      <div>{contact_details ? contact_details : '[Contact details]'}</div>
    </div>
  );
};

export default TwelveStepTemplate;
